import '../../../../assets/css/subscreens/customer/home/testimonial/Testimonial.css';
import { useState, useEffect, useRef, useCallback, useContext } from "react";
import { 
  Star, Quote, MessageCircle, Users, 
  ThumbsUp, Award, Sparkles, CheckCircle 
} from 'lucide-react';
import axios from "axios";
import AppContext from '../../../../context/AppContext';



function StarRating({ count = 5 }) {
  return (
    <div className="wht-stars">
      {Array.from({ length: count }).map((_, i) => (
        <Star key={i} size={18} fill="#f59e0b" color="#f59e0b" />
      ))}
    </div>
  );
}

export default function WorkHubTestimonials() {
  const {baseUrl, baseUrlForFile} = useContext(AppContext);
  const [current, setCurrent] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [animDir, setAnimDir] = useState("next");
  const timerRef = useRef(null);
  const [visibleCount, setVisibleCount] = useState(3);
  const [TESTIMONIALS,setTestimonials] = useState([]);

  useEffect(() => {
    const update = () => {
      if (window.innerWidth < 600) setVisibleCount(1);
      else if (window.innerWidth < 900) setVisibleCount(2);
      else setVisibleCount(3);
    };
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);
// fetch reviews
useEffect(()=>{




 axios.get(`${baseUrl}/customer/reviews`)
.then(res => {

    const reviews = res.data.customer_reviews;
 console.log("SUCCESS RESPONSE:", res.data);
  const formatted = reviews.map(item => ({
    id:item.id,

    name:item.whcustomer?.fullName || "Customer",

 role:
item.whpostjob?.address 
? item.whpostjob.address
: "Verified Customer",


    avatar:
    item.whcustomer?.image
    ?
    `${baseUrlForFile}/${item.whcustomer.image}`
    :
    "https://randomuser.me/api/portraits/women/44.jpg",


    text:item.customerreview,

    rating:item.customerrating,

    verified:true
}));

    setTestimonials(formatted);

})
.catch(err => {

    console.log("ERROR OBJECT:", err);

    console.log("ERROR RESPONSE:", err.response);

    console.log("ERROR DATA:", err.response?.data);

    console.log("ERROR MESSAGE:", err.message);

});


},[]);
  const maxIndex = TESTIMONIALS.length - visibleCount;

  const next = useCallback(() => {
    setAnimDir("next");
    setCurrent((p) => (p >= maxIndex ? 0 : p + 1));
  }, [maxIndex]);

  const prev = useCallback(() => {
    setAnimDir("prev");
    setCurrent((p) => (p <= 0 ? maxIndex : p - 1));
  }, [maxIndex]);

  useEffect(() => {
    if (isHovered) return;
    timerRef.current = setInterval(next, 4500);
    return () => clearInterval(timerRef.current);
  }, [isHovered, next]);

  useEffect(() => {
    setCurrent((p) => Math.min(p, maxIndex));
  }, [maxIndex]);

  const cardW = 100 / visibleCount;

  return (
    <section
      className="wht-section"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      
      {/* Background Elements */}
      <div className="wht-bg-pattern" />
      <div className="wht-bg-circle wht-bg-circle--1" />
      <div className="wht-bg-circle wht-bg-circle--2" />

      {/* Header */}
      <div className="wht-header">
        <div className="wht-badge">
          <MessageCircle size={16} />
          <span>TESTIMONIALS</span>
        </div>
        
        <h2 className="wht-title">
          What Our Customers Say About Us
        </h2>
        
        <p className="wht-subtitle">
          Real stories from real customers who trust WorkHub for their home service needs
        </p>

        {/* Stats */}
        {/* <div className="wht-stats">
          <div className="wht-stat">
            <Users size={24} />
            <div className="wht-stat-content">
              <div className="wht-stat-value">50K+</div>
              <div className="wht-stat-label">Happy Customers</div>
            </div>
          </div>
          <div className="wht-stat">
            <Award size={24} />
            <div className="wht-stat-content">
              <div className="wht-stat-value">4.8★</div>
              <div className="wht-stat-label">Average Rating</div>
            </div>
          </div>
          <div className="wht-stat">
            <ThumbsUp size={24} />
            <div className="wht-stat-content">
              <div className="wht-stat-value">98%</div>
              <div className="wht-stat-label">Satisfaction Rate</div>
            </div>
          </div>
        </div> */}



        {/* Slider */}
      <div className="wht-slider-outer">
        <div className="wht-track-wrap">
          <div
            className="wht-track"
            style={{
              transform: `translateX(${-(current * cardW)}%)`,
              transition: "transform 0.6s cubic-bezier(0.4,0,0.2,1)",
            }}
          >
            {TESTIMONIALS.map((t, i) => {
              const isCenter = visibleCount === 3
                ? i === current + 1
                : i === current;
              return (
                <div
                  className={`wht-card${isCenter ? " wht-card--center" : ""}`}
                  key={t.id}
                  style={{ width: `${cardW}%` }}
                >
                  {/* Avatar on top */}
                  <div className="wht-avatar-wrap">
                    <img src={t.avatar} alt={t.name} className="wht-avatar" />
                    <div className="wht-avatar-ring" />
                  </div>

                  {/* Quote icon */}
                  <div className="wht-quote-icon">"</div>

                  {/* Stars */}
                  <StarRating count={t.rating} />

                  {/* Text */}
                  <p className="wht-text">{t.text}</p>

                  {/* Name */}
                  <div className="wht-person">
                    <strong className="wht-name">{t.name}</strong>
                    <span className="wht-role">{t.role}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Arrows */}
        <button className="wht-arrow wht-arrow--prev" onClick={prev} aria-label="Previous">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="18" height="18">
            <path d="M15 18l-6-6 6-6" />
          </svg>
        </button>
        <button className="wht-arrow wht-arrow--next" onClick={next} aria-label="Next">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="18" height="18">
            <path d="M9 18l6-6-6-6" />
          </svg>
        </button>
      </div>

      {/* Dots */}
      <div className="wht-dots">
        {Array.from({ length: maxIndex + 1 }).map((_, i) => (
          <button
            key={i}
            className={`wht-dot${i === current ? " wht-dot--active" : ""}`}
            onClick={() => setCurrent(i)}
          />
        ))}
      </div>
      </div>

     


    </section>
  );
}



